import React from "react";
import { useState } from "react";
import QuoteBar from "./QuoteBar";

function Header(props){

    /*props

    total_hours
    reset
    htu
    handleAdd
    printContent
    */

    const [addButtonToggle, setAddButtonToggle] = useState(true)

    function handleClick(){
        setAddButtonToggle(!addButtonToggle);
        if(addButtonToggle){
            document.querySelector('.add-button').textContent = "-";
        }else if(!addButtonToggle){
            document.querySelector('.add-button').textContent = "+";
        }
        props.handleAdd();
    }



    let temp = props.total_productive_hours;
    let style = ""
    if(temp <= 5){
        style = "total_productive_percentage_red";
    }else if(temp > 5){
        style = "total_productive_percentage_orange";
    }else if(temp > 8){
        style = "total_productive_percentage_green";
    }
    return(

        <header>
            <h1>Productivity Calculator</h1>
            <QuoteBar />
            <div>Hover over a button to learn more</div>
            <div class="header_buttons">
            <button onClick={props.htu} title="More information about the app">Information</button>
            <button class="add-button" title="Toggle submission form" onClick={handleClick}>+</button>
            <button onClick={props.reset} title="Reset submissions (Does not clear browser data)">Reset</button>
            <button title="Export data to printable format" onClick={props.print}>Export</button>
            
            <button onClick={props.handleSave} id="saveBtn" title="Save data to browser">Save</button>
            <button onClick={props.handleLoad} id="loadBtn" title="Load data from browser">Load</button>
            <button onClick={props.handleClear} title="Clear browser data" id="storage-buttons-clear">Clear</button>
            </div>
            <div class="result">Total Hours : 
            <span class="total_hours"> {props.total_hours}</span> <br /> <br />
             Your day has been <span class={style}> 
                 {(props.total_productive_hours / 24 * 100).toFixed(2)} % 
                 </span> Productive</div> <br/>


            {props.total_productive_hours <= 5 && <p class={style}>Keep Trying!</p>}
            {props.total_productive_hours > 5 && props.total_productive_hours < 8 && <p class={style}>You did a lot today!</p>}
            {props.total_productive_hours > 8 && <p class={style}>Way to go!</p>}
        </header>
        
        // <header>
        //     <h1>Productivity Calculator</h1>
        //     <div class="header_buttons">
        //     <button class="add-button" onClick={handleClick}>+</button>
        //     <button onClick={props.htu}>How to Use</button>
        //     <button onClick={props.reset}>Reset</button>
        //     <button>Export</button>
        //     </div>
        //     <div class="result">Total Hours : 
        //     <span class="total_hours"> {props.total_hours}</span> <br /> <br />
        //      Your day has been <span class={style}> 
        //          {(props.total_productive_hours / 24 * 100).toFixed(2)} % 
        //          </span> Productive</div> <br/>


        //     {props.total_productive_hours <= 5 && <p class={style}>Keep Trying!</p>}
        //     {props.total_productive_hours > 5 && props.total_productive_hours < 8 && <p class={style}>You did a lot today!</p>}
        //     {props.total_productive_hours > 8 && <p class={style}>Way to go!</p>}
        // </header>
    )
}

export default Header;